import api from './api';

const userService = {
    getAdminUsers: async () => {
        const response = await api.get('/api/admin/users/');
        return response.data;
    },

    createAdminUser: async (userData) => {
        const response = await api.post('/api/admin/users/', userData);
        return response.data;
    },

    deleteAdminUser: async (userId) => {
        const response = await api.delete(`/api/admin/users/${userId}/`);
        return response.data;
    }
};

export default userService;
